import { Link, useLocation, useNavigate } from "react-router-dom";
import ResponsiveImage from "@/components/ui/responsive-image";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToWaitlist = () => {
    // If not on home page, navigate home first with the scroll parameter
    if (location.pathname !== '/') {
      navigate('/?scrollToWaitlist=true');
    } else {
      // If already on home page, just scroll
      document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile menu if it's open
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#FF7063]">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/images/new-logo/new-impause-logo.png" 
              alt="Impause"
              className="h-7 w-auto"
              width={32}
              height={32}
              loading="eager"
            />
            <span className="text-white font-medium text-base" style={{ fontFamily: 'DM Sans, sans-serif' }}>impause</span>
          </Link>

          <nav className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2">
            <Link to="/" className="text-white hover:opacity-80 transition-colors font-medium">
              Home
            </Link>
            <Link to="/future-you" className="text-white hover:opacity-80 transition-colors font-medium">
              FutureYou
            </Link>
            <Link to="/quiz" className="text-white hover:opacity-80 transition-colors font-medium">
              Quiz
            </Link>
            <Link to="/tools" className="text-white hover:opacity-80 transition-colors font-medium">
              Tools
            </Link>
            <Link to="/blog" className="text-white hover:opacity-80 transition-colors font-medium">
              Blog
            </Link>
            <Link to="/contact" className="text-white hover:opacity-80 transition-colors font-medium">
              Contact
            </Link>
          </nav>

          <div className="flex items-center space-x-4">
            {/* Desktop waitlist button */}
            <button
              className="hidden sm:block px-4 py-2 bg-[#F5E6D3] text-[#FF7063] rounded-lg hover:bg-opacity-90 transition-colors font-medium"
              onClick={scrollToWaitlist}
            >
              Join Waitlist
            </button>
            
            {/* Mobile menu button */}
            <button 
              className="md:hidden p-2 text-white" 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#FF7063] shadow-lg">
          <div className="container mx-auto px-4 py-4">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/future-you" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                FutureYou
              </Link>
              <Link 
                to="/quiz" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Quiz
              </Link>
              <Link 
                to="/tools" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Tools
              </Link>
              <Link 
                to="/blog" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <Link 
                to="/contact" 
                className="text-white text-lg py-3 px-4 rounded-lg hover:bg-white/10 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
              <button
                className="text-left text-lg py-3 px-4 mt-2 bg-[#F5E6D3] text-[#FF7063] rounded-lg hover:bg-opacity-90 transition-colors font-medium"
                onClick={scrollToWaitlist}
              >
                Join Waitlist
              </button>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}